import React from "react"
import { ActionMeta, ValueType } from "react-select"
import { Select } from "../../../Select/Select"
import { useTranslation } from "react-i18next"
import styles from "./PaginationSelect.module.scss"
import cn from "classnames"
import { usePaginationSelect } from "../helpers/usePaginationSelect"
import { formTranslation } from "../../../../locales/form"
import ErrorMessage from "../../../ErrorMessage/ErrorMessage"
import { SelectCustomProps } from "../../../Select/Select.types"
import { GetOptionsType } from "../helpers/types"
import MenuList from "../MenuList/MenuList"
import SearchIndicatorsContainer from "../SearchIndicatorsContainer/SearchIndicatorsContainer"

export interface PaginationSelectBaseProps extends SelectCustomProps {
    dataTestId: string
    getOptions: GetOptionsType
    onChange: (
        value: ValueType<{ label: string; value: string }, false>,
        actionMeta: ActionMeta<{ label: string; value: string }>
    ) => void
    className?: string
    errorText?: string
    label?: string
}

export const PaginationSelectBase: React.FC<PaginationSelectBaseProps> = props => {
    const { className, label, getOptions, onChange, errorText, dataTestId, ...restProps } = props
    const { t } = useTranslation()
    const { options, inputValue, handleInputChange, handleOnMenuScrollToBottom, handleOnMenuClose, handleOnMenuOpen } =
        usePaginationSelect(getOptions)

    return (
        <div data-testid={dataTestId} className={cn(styles.paginationSelect, className)}>
            {label && <div className={styles.paginationSelect_label}>{label}</div>}
            <Select
                options={options}
                inputValue={inputValue}
                onInputChange={handleInputChange}
                onMenuClose={handleOnMenuClose}
                onChange={onChange}
                onMenuOpen={handleOnMenuOpen}
                onMenuScrollToBottom={handleOnMenuScrollToBottom}
                noOptionsMessage={() => t(formTranslation.noResultsFound)}
                //Отключение встроенной фильтрации в React Select
                filterOption={() => true}
                components={{
                    MenuList,
                    IndicatorsContainer: SearchIndicatorsContainer
                }}
                {...restProps}
            />
            {errorText && <ErrorMessage text={errorText} />}
        </div>
    )
}
